import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  InputGroup,
  Glyphicon,
  Image,
  ListGroup,
  ListGroupItem,
  Badge,
  Well,
  Tab
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import isEmpty from "lodash.isempty";

import {getSiteStatus}    from '../../../redux/actions/siteActions';

import {
  currentDealList
} from "../../../redux/actions/frontActions";

import {
  getMenuList,
  //getQuantityCart,
  getCartDetail,
  userLogout,
  getSiteCity
} from "../../../redux/actions/frontActions";
import siteLogo from "../../../img/ddb-logo.png";
import './Header.css'

import languageConfig from "../../../config/languageConfig";
import UseDfpSlot from "../dashboard/UseDfpSlot";
import ScriptSlot from "../dashboard/ScriptSlot";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const history = createBrowserHistory();
class FrontHeader extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props, context) {
    super(props, context);
    this.state = {
      search: "",
      themeData: {},
      menuStyles: {},
      mmenuStyles: {},
      topMenuStyles:{},
      mtopMenuStyles:{},
      headerStyles:{},
      mheaderStyles:{},
      menuBgStyles: {},
      mmenuBgStyles: {},
      mmenuTopStyles: {},
      merchantLogo:"",
      cityList:[],
      default_city: "",
      notifications: "",
      width: 0, 
      height: 0,
      nearestLocation: false,
      search_deals: 'off',
      search_deals_on_dektop: 'enable',
      show_menu_on_desktop: 'enable',
      show_menu_on_mobile: 'enable',
      search_location: 'off',
      hover: false,
      multi_lang: 'no',
      lang: '',
      default_lang: (cookies.get('default_lang') ? cookies.get('default_lang') : 'en'),
      MenuOpen:"",
      cityArr:[],
      stateArr:[],
      cityTitle:'',
      siteKey:'',
      stateAbbr:'',
      stateAbbr1:'',
      CheckoutDeal:0
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.logout = this.logout.bind(this);
    this.handleSearchText = this.handleSearchText.bind(this);
    this.setDefaultCity = this.setDefaultCity.bind(this);
    this.setDefaultCity2 = this.setDefaultCity2.bind(this);
    this.showcity = this.showcity.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this); 
    this.handleClickOutside = this.handleClickOutside.bind(this); 
  }

  sendMessage = () => {
    var searchText = $("#search").val();
    if(searchText!=""){
      window.location = `/search-deal/${searchText}`; 
    }
  }

  onMouseEnter = (id) => {
    this.setState({MenuOpen:id});
  }
  onMouseLeave = (id) => {
    this.setState({MenuOpen:""});
  }
  hoverOn = (e) => {
    this.setState({ hover: true, hoverID: e.target.attributes.getNamedItem("data-id").value });
  }

  hoverOff = (e) => { 
    this.setState({ hover: false, hoverID: e.target.attributes.getNamedItem("data-id").value });    
  }

  logout = () => {
    this.props.userLogout();
  }

  getValidUrl = (url = "") => {
    let newUrl = window.decodeURIComponent(url);
    newUrl = newUrl.trim().replace(/\s/g, "");

    if(/^(:\/\/)/.test(newUrl)){
      return `http${newUrl}`;
    }
    if(!/^(f|ht)tps?:\/\//i.test(newUrl)){
        return `http://${newUrl}`;
      }

      return newUrl;
    }
  setDefaultCity = (e) => {     
    if("setDefaultCity"+e.target.value){
      //alert(e.target.value);
      let d = new Date();
      d.setTime(d.getTime() + 480 * 60 * 1000);
      cookies.set("cityID", e.target.value, { path: "/", expires: d });
      cookies.set("akash", e.target.value, { path: "/", expires: d });

      let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
      siteData.default_city = e.target.value;
      localStorage.setItem('siteDDBStatus', JSON.stringify(siteData));
      this.setState({
        default_city: e.target.value
      });
      this.props.getSiteStatus(e.target.value); 
      this.props.getMenuList({page:1, lang: this.state.default_lang, cityID: e.target.value});
      this.props.updateSiteProperties(e.target.value);
      this.context.router.history.push(`/city-deal/${e.target.value}`);
      window.location.reload();
    }
  }

  setDefaultCity2 = (event) => {
    if(event.target.id){
      let d = new Date();
      d.setTime(d.getTime() + 480 * 60 * 1000);
      cookies.set("cityID", event.target.id, { path: "/", expires: d });

      let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
      siteData.default_city = event.target.id;
      localStorage.setItem('siteDDBStatus', JSON.stringify(siteData));
      this.setState({
        default_city: event.target.id
      });
      if(siteData.active_cities){
        var cityTitle = '';
        var stateAbbr='';
        siteData.active_cities.map((idex, key)=> {
          idex.cities.map((val, idx)=> { 
            if(val.cityID == siteData.default_city) {
              cityTitle = val.title;
              stateAbbr=val.stateAbbr;
            } 
          })
        });
        this.setState({ 
          cityTitle:cityTitle,
          stateAbbr:stateAbbr,
          stateAbbr1:stateAbbr,
        });
      }
      this.props.getSiteStatus(event.target.id); 
      this.props.getMenuList({page:1, lang: this.state.default_lang, cityID: event.target.id});
      this.props.updateSiteProperties(event.target.id);
      this.context.router.history.push(`/city-deal/${event.target.id}`);
    }
  }
  //test
  setDefaultLanguage = (lang) => {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    siteData.default_lang = lang; 
    localStorage.setItem('siteDDBStatus', JSON.stringify(siteData));
    this.setState({
        default_lang: lang,
        lang: lang
    });
    
    let d = new Date();
    d.setTime(d.getTime() + 480 * 60 * 1000);
    cookies.set("default_lang", lang, { path: "/", expires: d });

    this.props.setLanguage(lang);
    //alert(siteData.default_city);
    this.props.getSiteStatus(lang); 
    this.props.getSiteStatus(siteData.default_city); 
    this.props.getMenuList({page:1, lang: lang, cityID: siteData.default_city});
    if(cookies.get('token')){
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: lang});
      this.props.getCartDetail({'userKey':cookies.get('token'), lang: lang});
    }

    if(window.location.href.indexOf("register") > -1 || window.location.href.indexOf("become-partner") > -1 || window.location.href.indexOf("checkout") > -1){
      window.location.reload();  
    }

  }

  handlePageChange = page => {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData){
      if(siteData.default_city || siteData.multi_lang == "yes"){ 
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get('default_lang') ? cookies.get('default_lang') : siteData.default_lang,
        });
      }
    }

    this.setState({
      currentPage: page,
      cartTotal: 0
    });
    if(cookies.get('token')){
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: (siteData && siteData.default_lang) ? siteData.default_lang : this.state.default_lang});
      this.props.getCartDetail({'userKey':cookies.get('token'), lang: (siteData && siteData.default_lang) ? siteData.default_lang : this.state.default_lang});
    }
  };

  handleSearchText(e){
    this.setState({[e.target.name]:e.target.value});
    if (e.key === 'Enter') {
      this.handleSearch();
    }
  };

  handleSearch(e) {
    if (this.state.search && this.state.search.length > 0) {
      this.context.router.history.push(`/search-deal/${this.state.search}`);
    }}

  
  setWrapperRef(node) { 
    this.wrapperRef = node; 
  }


  /**
   * Alert if clicked on outside of element
   */ 

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({stateAbbr1:this.state.stateAbbr});
      if(event.target.id == 'login'){
        this.context.router.history.push(`/login`);
      }

      if(event.target.id == 'logout'){
        this.logout();
      }

      if(event.target.id == 'sendMessage'){
        this.sendMessage();
      }

      if(event.target.id == 'citySearch'){
        this.findNearestCity();
      }      

      if(event.target.id == 'my_account'){
        this.context.router.history.push(`/my-account`);
      }

      if(event.target.id == 'where'){
        this.context.router.history.push(`/order/status`);
      }

      if(event.target.id == 'lang'){
        this.setDefaultLanguage(document.getElementById('lang').getAttribute('value'));
      }

      if(event.target.id == 'cart'){
        this.context.router.history.push(`/cart`);
      }

      if(event.target.id == 'register'){
        this.context.router.history.push(`/register`);
      }

      if(event.target.id == 'search'){
        let search = document.getElementById(event.target.id);
        search.addEventListener("keypress", function(e) {
          document.getElementById(event.target.id).value = search.value;
          if(e.key == 'Enter' || e.key == 13){
            window.location = `/search-deal/${search.value}`;
          }
        });
      }

      if(event.target.id == 'location'){
        let activities = document.getElementById(event.target.id);
        activities.addEventListener("change", function() {
          let d = new Date();
          d.setTime(d.getTime() + 480 * 60 * 1000);
          cookies.set("cityID", activities.value, { path: "/", expires: d });

          let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
          siteData.default_city = activities.value;
          localStorage.setItem('siteDDBStatus', JSON.stringify(siteData));
          window.location = `/city-deal/${activities.value}`;
        });
      }
    }
  }
  componentDidMount() { 
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus')); 
    //alert("11"+siteData.default_city);
    if(siteData){
      if(siteData.default_city || siteData.multi_lang == "yes"){ 
        this.setState({
          default_city: (cookies.get('akash') ? cookies.get('akash') : siteData.default_city),
          notifications: siteData.notifications,
          search_location_mobile: siteData.search_location,
          search_location: siteData.search_loc_on_dektop,
          search_deals: siteData.search_deals,
          search_deals_on_dektop: siteData.search_deals_on_dektop,
          show_menu_on_desktop: siteData.show_menu_on_desktop,
          show_menu_on_mobile: siteData.show_menu_on_mobile,
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get('default_lang') ? cookies.get('default_lang') : siteData.default_lang,
          siteData:siteData,
          siteKey:siteData.siteKey,
        });
      }
      if(siteData.active_cities){
        this.setState({
          cityList: siteData.active_cities
        }); 
        var cityArr = [];
        var stateArr = [];
        var cityTitle = '';
        var stateAbbr='';
        siteData.active_cities.map((idex, key)=> {
          idex.cities.map((val, idx)=> {
            cityArr.push(val);
            if(val.cityID == siteData.default_city) {
              cityTitle = val.title;
              stateAbbr=val.stateAbbr;
            }
            if (stateArr.indexOf(val.stateAbbr) === -1) {
              stateArr.push(val.stateAbbr)
            }
          })
        });
        this.setState({
          cityArr: cityArr,
          stateArr: stateArr,
          cityTitle:cityTitle,
          stateAbbr:stateAbbr,
          stateAbbr1:stateAbbr,
        });
      }
    }else{
        this.props.getSiteStatus();     
    }

    if((siteData && siteData.header_content  && siteData.header_content.dynamic_header_status == 'enable' && siteData.header_content.header_content !== '')){
      document.addEventListener('mousedown', this.handleClickOutside);
    }

    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);

    if(siteData)
  {
    this.handlePageChange(1);
    if(isEmpty(this.props.menuList)){ 
      this.props.getMenuList({page:1, lang: (cookies.get('default_lang') ? cookies.get('default_lang') : siteData.default_lang), cityID: (cookies.get('akash') ? cookies.get('akash') : siteData.default_city)});
    }
  }
    // this.props.getSiteCity();


    if (this.props.themeData) {
      this.setState({
        themeData: this.props.themeData
      });

      if (this.props.themeData.favicon) {
        var link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = (this.props.themeData.favicon) ? this.props.themeData.favicon : 'PayVibe';
        document.getElementsByTagName("head")[0].appendChild(link);
      }

      if (this.props.themeData.menu_bar) {
        this.setState({
          menuStyles: {
            color: this.props.themeData.menu_bar.menu_bar_text
          },
          menuBgStyles: {
            backgroundColor: this.props.themeData.menu_bar.menu_bar_color
          },
          topMenuStyles: {
            backgroundColor: this.props.themeData.menu_bar.top_menu_bar
          },
          menuTopStyles:{
            color: this.props.themeData.menu_bar.top_menu_bar
          }
        });
      }else{
        this.setState({
          menuStyles: {
            color: ''
          },
          menuBgStyles: {
            backgroundColor: ''
          },
          topMenuStyles: {
            backgroundColor: ''
          },
          menuTopStyles:{
            color: ''
          }
        });
      }

      if(this.props.themeData.button){
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }else{
        this.setState({
          button_color: '',
          mouseover_color: '',
        });
      }

      if (this.props.themeData.header) {
        this.setState({
          headerStyles: {
            backgroundColor: this.props.themeData.header
          }
        });
      }else{
        this.setState({
          headerStyles: {
            backgroundColor: '',
          }
        });
      }
    }
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentWillReceiveProps(nextProps) { 
    if(cookies.get('default_lang') != this.state.default_lang){
      if(typeof cookies.get('default_lang') != 'undefined'){ 
        this.setState({
          siteData: nextProps.siteStatus, 
          multi_lang: nextProps.siteStatus.multi_lang, 
          default_lang: cookies.get('default_lang') ? cookies.get('default_lang') : nextProps.siteStatus.default_lang
        });
        this.setDefaultLanguage(cookies.get('default_lang'));
      }
    }
    if(this.props.logoutStatus != nextProps.logoutStatus){
      if(nextProps.logoutStatus){
        if(nextProps.logoutStatus.status == 'success'){
          let siteData = nextProps.siteStatus;
          siteData.default_lang = this.state.default_lang;
          localStorage.setItem('siteDDBStatus', JSON.stringify(siteData));
          this.setState({siteData: nextProps.siteStatus, multi_lang: (this.state.multi_lang) ? this.state.multi_lang : nextProps.siteStatus.multi_lang, default_lang: (this.state.default_lang) ? this.state.default_lang : nextProps.siteStatus.default_lang});

          let d = new Date();
          d.setTime(d.getTime() + 480 * 60 * 1000);
          cookies.set("default_lang", this.state.default_lang, { path: "/", expires: d });

          this.props.setLanguage(this.state.default_lang);
          this.props.getSiteStatus(this.state.default_lang); 
          this.props.getMenuList({page:1, lang: this.state.default_lang, cityID: this.state.default_city});
        }
      }
    }
    if(this.props.currentCityID != nextProps.currentCityID && this.state.nearestLocation == true){
      if(nextProps.currentCityID){
        this.setState({default_city: nextProps.currentCityID.data.requested_city, nearestLocation: false})
        this.props.getSiteStatus( nextProps.currentCityID.data.requested_city ); 
        this.props.getMenuList({page:1, lang: this.state.default_lang, cityID: nextProps.currentCityID.data.requested_city});
        // history.push(`/city-deal/${nextProps.currentCityID.data.requested_city}`);        
      }
    }

    //alert(this.state.default_city);
    /*start-akash rai-14-03-2022*/
    if(nextProps.route.match.params && nextProps.route.match.params.cityID && nextProps.route.match.params.cityID.length > 0  && nextProps.route.match.params.cityID != this.state.default_city){
      //alert(nextProps.route.match.params+"&&"+nextProps.route.match.params.cityID+"&&"+nextProps.route.match.params.cityID.length+">0"+"&&"+nextProps.route.match.params.cityID+"!="+this.state.default_city)
      
      if(nextProps.route.match.params.cityID == "preview"){
        this.setState({
          default_city: nextProps.siteStatus.default_city//nextProps.route.match.params.cityID
        });
      }else{
        this.setState({
          default_city: nextProps.route.match.params.cityID
        });
      }

      let a;
      if(nextProps.route.match.params.cityID == "preview"){
        a = nextProps.siteStatus.default_city;//nextProps.route.match.params.cityID
      }else{
         a = nextProps.route.match.params.cityID;
      }
      
      let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
      siteData.default_city = a;
      //alert("a"+a);
      localStorage.setItem('siteDDBStatus', JSON.stringify(siteData));
      //this.handlePageChange(1);
    }
    /*end-akash rai-14-03-2022*/

    if(this.props.siteStatus != nextProps.siteStatus){
      if(nextProps.siteStatus){
        if(nextProps.siteStatus.dynamic_header == 1 && nextProps.siteStatus.header_content.dynamic_header_status == 'enable' && nextProps.siteStatus.header_content.header_content != ''){
           document.addEventListener('mousedown', this.handleClickOutside); 
          this.setState({siteData: nextProps.siteStatus, multi_lang: (this.state.multi_lang) ? this.state.multi_lang : nextProps.siteStatus.multi_lang, default_lang: (this.state.default_lang) ? this.state.default_lang : nextProps.siteStatus.default_lang});
        }

        if(this.state.default_city === nextProps.siteStatus.default_city){
          this.setState({
            default_city: (this.state.default_city) ? this.state.default_city : nextProps.siteStatus.default_city,
            notifications: nextProps.siteStatus.notifications,
          });
        }else{
          this.setState({
            default_city: (this.state.default_city) ? this.state.default_city : nextProps.siteStatus.default_city,
            notifications: this.state.notifications,
          });
        }
        localStorage.setItem('siteDDBStatus', JSON.stringify(nextProps.siteStatus));
        // if(nextProps.siteStatus && nextProps.siteStatus.default_lang){
        //   this.setDefaultLanguage(nextProps.siteStatus.default_lang);
        // }
        //this.props.updateSiteProperties((this.state.default_city) ? this.state.default_city : nextProps.siteStatus.default_city);
      }
    } 
    if (nextProps.themeData) {
      this.setState({
        themeData: nextProps.themeData
      });

      if (nextProps.themeData.favicon) {
        var link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = (nextProps.themeData.favicon) ? nextProps.themeData.favicon : 'PayVibe';
        document.getElementsByTagName("head")[0].appendChild(link);
      }

      if (nextProps.themeData.menu_bar) {
        this.setState({
          menuStyles: {
            color: nextProps.themeData.menu_bar.menu_bar_text
          },
          menuBgStyles: {
            backgroundColor: nextProps.themeData.menu_bar.menu_bar_color
          },
          topMenuStyles: {
            backgroundColor: nextProps.themeData.menu_bar.top_menu_bar
          },
          menuTopStyles:{
            color: nextProps.themeData.menu_bar.top_menu_bar
          }
        });

        // document.getElementById("basic-nav-dropdown").setAttribute("style", "font-size: 100px; font-style: italic; color:#000;");;
      }else{
        this.setState({
          menuStyles: {
            color: ''
          },
          menuBgStyles: {
            backgroundColor: ''
          },
          topMenuStyles: {
            backgroundColor: ''
          },
          menuTopStyles:{
            color: ''
          }
        });
      }

      if(nextProps.themeData.button){
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }else{
        this.setState({
          button_color: '',
          mouseover_color: '',
        });
      }

      if (nextProps.themeData.header) {
        this.setState({
          headerStyles: {
            backgroundColor: nextProps.themeData.header
          }
        });
      }else{
        this.setState({
          headerStyles: {
            backgroundColor: '',
          }
        });
      }
    }
    if (nextProps.menuList) {
      this.setState({ menuList: nextProps.menuList });
    }
    if(nextProps.curDeal && nextProps.curDeal.merchantStore && (nextProps.route.match.path == '/store/:merchantID?' || nextProps.route.match.path == '/store-detail/:dealID?/:cityID?/:affiliateID?')){
      let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
      this.setState({
          default_city: (cookies.get('akash') ? cookies.get('akash') : siteData.default_city)
        });
      if(nextProps.curDeal.merchantStore.header){
        this.setState({
              mheaderStyles: {
                backgroundColor: nextProps.curDeal.merchantStore.header
              }
            });
      }else{
        this.setState({
            mheaderStyles: {
              backgroundColor: '',
            }
        });
      }
      if(nextProps.curDeal.merchantStore.menu_bar){
        this.setState({
          mmenuStyles: {
            color: nextProps.curDeal.merchantStore.menu_bar.menu_bar_text
          },
          mmenuBgStyles: {
            backgroundColor: nextProps.curDeal.merchantStore.menu_bar.menu_bar_color
          },
          mtopMenuStyles: {
            backgroundColor: nextProps.curDeal.merchantStore.menu_bar.top_menu_bar
          },
          mmenuTopStyles:{
            color: nextProps.curDeal.merchantStore.menu_bar.top_menu_bar
          }
        });
      }else{
        this.setState({
          mmenuStyles: {
            color: ''
          },
          mmenuBgStyles: {
            backgroundColor: ''
          },
          mtopMenuStyles: {
            backgroundColor: ''
          },
          mmenuTopStyles:{
            color: ''
          }
        });
      }
      if(nextProps.curDeal.merchantStore.button){
        this.setState({
          mbutton_color: nextProps.curDeal.merchantStore.button.button_color,
          mmouseover_color: nextProps.curDeal.merchantStore.button.mouseover_color,
            });
      }else{
        this.setState({
          mbutton_color: '',
          mmouseover_color: '',
        });
      }
      if(nextProps.curDeal.merchantStore.replaceMainSiteLogo == 1 && nextProps.curDeal.merchantStore.merchantLogo){
          this.setState({
            merchantLogo: nextProps.curDeal.merchantStore.merchantLogo,
          });
        }else{
          this.setState({
            merchantLogo: '',
          });
      }
    }

    if (this.props.cartDetail != nextProps.cartDetail) {
      if (nextProps.cartDetail) {
        let total = 0;
        nextProps.cartDetail.data.data.map((cart, index) => (total += parseInt(cart.quantity)));
        this.setState({ cartTotal: total, CheckoutDeal: (nextProps.cartDetail.data && nextProps.cartDetail.data.CheckoutDeal ? nextProps.cartDetail.data.CheckoutDeal : 0)});
      }
    }

    // if (this.props.cartQuantity != nextProps.cartQuantity) {
    //   if (nextProps.cartQuantity) {
    //     let total = 0;
    //     console.log('nextProps.cartQuantity', nextProps.cartQuantity.data.data)
    //     //nextProps.cartDetail.data.data.map((cart, index) => (total += parseInt(cart.quantity)));
    //     this.setState({cartTotal: (nextProps.cartQuantity.data && nextProps.cartQuantity.data.data ? nextProps.cartQuantity.data.data : 0)});
    //   }
    // }

    // update cart status
    if (this.props.cartStatus != nextProps.cartStatus) {
      if (
        nextProps.cartStatus &&
        nextProps.cartStatus.userKey == cookies.get("token")
      ) {
        if(cookies.get('token')){
          //this.props.getQuantityCart({ userKey: cookies.get("token"), lang: this.state.default_lang });
          this.props.getCartDetail({ userKey: cookies.get("token"), lang: this.state.default_lang });
        }
      }
    }

    if(this.props.cityList != nextProps.cityList){
      if(nextProps.cityList){
        this.setState({cityList: nextProps.cityList.data});
      }
    }
  }

  displayLogo() {
    if(this.state.multi_lang=='yes' && this.state.default_lang=='fr' && this.state.themeData.french_logo && this.state.themeData.french_logo!="") {
      return this.state.themeData.french_logo;
    } else if(this.state.themeData.logo && this.state.themeData.logo != "") {
      return this.state.themeData.logo;
    } else {
      return siteLogo;
    }
  }

  setTitle(title){
    return (<span style={ this.state.mmenuStyles.color ? this.state.mmenuStyles : this.state.menuStyles }>{title}</span>)
  }

 findNearestCity = () => {
   
   const postData = {
      page: 1,
      latitude: "26.846695",
      longitude: "80.946167",
      limit: 10,
      cityID: this.state.default_city,
      force_geolocation : 'yes',
    };
    this.setState({nearestLocation: true});
    this.props.currentDealList(postData);
  }

dynamicHeader = (content) => {
    let newContent = '';
    if(content){
      let login, account, where, lang, cart, search, location, locationwithstate;
      let locationData;

      if(localStorage.getItem("user")){
        login = `<a id="logout" style="color: ${(this.state.menuTopStyles) ? this.state.menuTopStyles.color : ''}"><i class="glyphicon glyphicon-log-out"></i> ${languageConfig[this.state.default_lang].logout}</a>`
      }else{
        login = `<a id="login" style="color: ${(this.state.menuTopStyles) ? this.state.menuTopStyles.color : ''}"><i class="glyphicon glyphicon-log-in"></i> ${languageConfig[this.state.default_lang].login}</a>`;
      }
      content = content.replace("${logout}", login);

      if(localStorage.getItem("user")){
        account = `<a id="my_account" style="color: ${(this.state.menuTopStyles) ? this.state.menuTopStyles.color : ''}"><i class="glyphicon glyphicon-cog"></i> ${languageConfig[this.state.default_lang].my_account}</a>`
      }else{
        account = `<a id="register" style="color: ${(this.state.menuTopStyles) ? this.state.menuTopStyles.color : ''}"><i class="glyphicon glyphicon-user"></i> ${languageConfig[this.state.default_lang].register}</a>`;
      }
      content = content.replace("${my_account}", account);

      if(this.state.multi_lang == 'yes'){
        if(this.state.default_lang == 'fr'){
          lang = `<a id="lang" value="en" style="color: ${(this.state.menuTopStyles) ? this.state.menuTopStyles.color : ''}"><i class="glyphicon glyphicon-globe"></i> English</a>`;
        }else{
          lang = `<a id="lang" value="fr" style="color: ${(this.state.menuTopStyles) ? this.state.menuTopStyles.color : ''}"><i class="glyphicon glyphicon-globe"></i> Français</a>`;
        }
        content = content.replace("${language}", lang);
      } else {
        content = content.replace("${language}", '');
      }

      content = content.replace("${where_my_order}", `<a id="where" style="color: ${(this.state.menuTopStyles) ? this.state.menuTopStyles.color : ''}"><i class="glyphicon glyphicon-briefcase"></i> ${languageConfig[this.state.default_lang].where}</a>`); 
      
      if(this.state.cartTotal){
        cart = `<a id="cart" style="color: ${(this.state.menuTopStyles) ? this.state.menuTopStyles.color : ''}"><i class="glyphicon glyphicon-shopping-cart"></i> ${languageConfig[this.state.default_lang].cart} <span class="badge badge-danger">${this.state.cartTotal}</span></a>`;
      }else{
        cart = `<a id="cart" style="color: ${(this.state.menuTopStyles) ? this.state.menuTopStyles.color : ''}"><i class="glyphicon glyphicon-shopping-cart"></i> ${languageConfig[this.state.default_lang].cart}</a>`;
      }
      content = content.replace("${cart}", cart);

      search = `<div class="form-group">
      <span class="input-group">
      <input name="search" id="search" 
      placeholder="${languageConfig[this.state.default_lang].search_deal}" type="text" class="form-control">
      <span data-id="dealSearch" class="input-group-addon" 
      style="background-color: ${this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color}; border: ${this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color}">
      <span class="glyphicon glyphicon-search" id="sendMessage"></span></span></span></div>`;
      content = content.replace("${search}", search);


            
      if (this.state.cityList !== "") {
        locationData += this.state.cityList.map((data, index) => (
          (data.cities) &&
              data.cities.map((city, index) => 
                (this.state.default_city == city.cityID) ?
                  `<option key=${'hcityval'+index} selected='selected' value=${city.cityID}>${city.title}</option>`
                :
                  `<option key=${'hcityval'+index} value=${city.cityID}>${city.title}</option>`
          )
        ));
      }

      location = `<div class="form-group"><span class="input-group"><select placeholder="select" id="location" class="form-control"><option value="">${languageConfig[this.state.default_lang].choose_region}</option>${locationData}</select><span data-id="location" class="input-group-addon" style="background-color: ${this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color}; border: ${this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color}"><span class="glyphicon glyphicon-map-marker" id="citySearch"></span></span></span></div>`;
      content = content.replace("${location}", location); 
      content = content.replace("${locationwithstate}", '');

      newContent = content;
    }
    if(newContent){
      return newContent;
    }
  }
 
  handleMenu = (permalink, target, type) => { 
    if(type !== ''){
      if(target=='blank' )
      { 
        window.open(type, target);
      }
      else
      {
       window.location.href = type;
      }
    }else{
      this.context.router.history.push(`/all-deal/${permalink}`)
    }
  }
  
  showcity = (event) => {
    this.setState({stateAbbr1:event.target.id});
  }

  render() {
    const { index, direction, default_city, width} = this.state;
    let header_content;
    let siteData = this.state.siteData;
    const isMobile = width >= 600; 

    let slocationfinal;

    if(this.state.search_location == 'disable'){
      slocationfinal = 'disable';
    }else{
      slocationfinal = 'enable';
    }

    if((siteData && siteData.header_content  && siteData.header_content.dynamic_header_status == 'enable')){
      if(siteData.footer_content.french_header_content !== '' && this.state.default_lang=='fr') {
        header_content = this.dynamicHeader(siteData.header_content.french_header_content);
      } else if (siteData.footer_content.header_content !== '') {
        header_content = this.dynamicHeader(siteData.header_content.header_content);
      }
      
    }

    //console.log(this.state.default_city);
    //console.log(cookies.get('akash'));

    //console.log("check"+(this.state.merchantLogo ? "merchant" : "custom" ))

    //citywise url
    let cityURL;

    if(this.state.merchantLogo){
      cityURL = "/";
    }else{
      //console.log(this.state.themeData.logo_destination_status);
      //console.log(this.state.themeData.logo_destination_value);

      if(this.state.themeData.logo_destination_status == 1){
        if(this.state.themeData.logo_destination_value == ""){
          cityURL = "/";
        }else{
          //console.log(this.state.themeData.city_id)
          if(this.state.default_city == this.state.themeData.city_id || this.state.themeData.city_id == "na"){
            cityURL = this.state.themeData.logo_destination_value;
          }else{
            cityURL = "/";
          }
        }
      }else{
        cityURL = "/";
      }
    }

    //console.log("cityURL:"+cityURL);

    this.state.default_city = (cookies.get('akash') ? cookies.get('akash') : ((siteData)?siteData.default_city:""));
        
    // Internet Explorer 6-11
    const isIE = /*@cc_on!@*/false || !!document.documentMode;
    // Edge 20+
    const isEdge = !isIE && !!window.StyleMedia;

    let menu; 
    if (!isEmpty(this.props.menuList)) {
      if(isIE == false && isEdge == false){
        menu = this.props.menuList.map(
          (cat, index) =>
            !isEmpty(cat.sub_category) ? (
              <NavDropdown
                key={Math.random() + index}
                title={this.setTitle(cat.parentcatName)}
                id="basic-nav-dropdown"
                style={{color: 'red !important'}}
                onMouseEnter={() => this.onMouseEnter(cat.parentcatID)} onMouseLeave={() => this.onMouseLeave(cat.parentcatID)} 
                open={this.state.MenuOpen==cat.parentcatID ? true : false}
                onClick={() =>
                  this.handleMenu(cat.parentcatPermalink, cat.target, (cat.parentcatType=='custom_link' && cat.other_link!='' ? cat.other_link : ''))
                }
              >
                {cat.sub_category.map((subcat, index) => (
                  <MenuItem
                    key={Math.random()}
                    onClick={() =>
                      this.handleMenu(subcat.catPermalink, subcat.target, (subcat.catType=='custom_link' && subcat.other_link!='' ? subcat.other_link : ''))
                    }
                    replace="true"
                  >
                    <span style={this.state.mmenuStyles.color ? this.state.mmenuStyles : this.state.menuStyles}>{subcat.catName}</span>
                  </MenuItem>
                ))}
              </NavDropdown>
            ) : (
              <NavItem
                style={this.state.mmenuStyles.color ? this.state.mmenuStyles : this.state.menuStyles}
                key={Math.random()}
                onClick={() =>
                  this.handleMenu(cat.parentcatPermalink, cat.target, (cat.parentcatType=='custom_link' && cat.other_link!='' ? cat.other_link : ''))
                }
                replace="true"
              >
                <span style={this.state.mmenuStyles.color ? this.state.mmenuStyles : this.state.menuStyles}> {cat.parentcatName} </span>
              </NavItem>
            )
        );
      }else{
          menu = this.props.menuList.map(
          (cat, index) =>
            !isEmpty(cat.sub_category) ? (
              <NavDropdown
                key={Math.random() + index}
                title={this.setTitle(cat.parentcatName)}
                id="basic-nav-dropdown"
                style={{color: 'red !important'}}
                onMouseDown={() => this.onMouseEnter(cat.parentcatID)} onMouseLeave={() => this.onMouseLeave(cat.parentcatID)} 
                open={this.state.MenuOpen==cat.parentcatID ? true : false}
                onClick={() =>
                  this.handleMenu(cat.parentcatPermalink, cat.target, (cat.parentcatType=='custom_link' && cat.other_link!='' ? cat.other_link : ''))
                }
              >
                {cat.sub_category.map((subcat, index) => (
                  <MenuItem
                    key={Math.random()}
                    onClick={() =>
                      this.handleMenu(subcat.catPermalink, subcat.target, (subcat.catType=='custom_link' && subcat.other_link!='' ? subcat.other_link : ''))
                    }
                    replace="true"
                  >
                    <span style={this.state.mmenuStyles.color ? this.state.mmenuStyles : this.state.menuStyles}>{subcat.catName}</span>
                  </MenuItem>
                ))}
              </NavDropdown>
            ) : (
              <NavItem
                style={this.state.mmenuStyles.color ? this.state.mmenuStyles : this.state.menuStyles}
                key={Math.random()}
                onClick={() =>
                  this.handleMenu(cat.parentcatPermalink, cat.target, (cat.parentcatType=='custom_link' && cat.other_link!='' ? cat.other_link : ''))
                }
                replace="true"
              >
                <span style={this.state.mmenuStyles.color ? this.state.mmenuStyles : this.state.menuStyles}> {cat.parentcatName} </span>
              </NavItem>
            )
        );
      }
    }
    let showcity = ((this.state.siteKey && (this.state.siteKey=='GPe8hapnbxW96tcO2BB32jgLiPEqvZonsPqVsLz4kQU=' || this.state.siteKey=='hEhNweI8U4TkdzJsZDU5JljMbQRZqbDbNnDM46hEBxE=' || this.state.siteKey == 'FlE6SAbrLsLdNSA+9c3cZHV7giaKn8Cgll0eX+VHyvk=' || this.state.siteKey == 'zpkt6AuqJMBkOGYBJnDrcuF9JE6bUg0JupDZShM2wpc=')) ? 1 : 0);
    

    return (
      <div style={this.state.mheaderStyles.backgroundColor ? this.state.mheaderStyles : this.state.headerStyles}>
        {this.props.isheader && 
          <div>
            {(header_content != '' && typeof header_content != 'undefined') ?
              <React.Fragment>
                {ReactHtmlParser(header_content)}
              </React.Fragment>
            :
              <div className="top-menu" style={this.state.mheaderStyles.backgroundColor ? this.state.mheaderStyles : this.state.headerStyles}>
                <div className="container">
                  <Row>
                    <Col lg={3} md={8} sm={12}>
                      <div className="Co-logo">
                        <a href={cityURL}><Image src={this.state.merchantLogo ? this.state.merchantLogo : this.displayLogo()} /></a>
                      </div>
                    </Col> 
                    <Col lg={9} md={4} sm={12}>
                      <div className="top-item">
                        <ListGroup className="topmenu">
                          <ListGroupItem style={this.state.mtopMenuStyles.backgroundColor ? this.state.mtopMenuStyles : this.state.topMenuStyles}>
                            <Link to={"/cart"} replace style={this.state.mmenuTopStyles.color ? this.state.mmenuTopStyles : this.state.menuTopStyles}>
                              <i className="glyphicon glyphicon-shopping-cart" /> {languageConfig[this.state.default_lang].cart}{" "}
                              {this.state.cartTotal ? (
                                <Badge bsStyle="danger">{this.state.cartTotal}</Badge>
                              ) : null}
                            </Link>
                          </ListGroupItem>
                          {localStorage.getItem("user") ? (
                            <ListGroupItem style={this.state.mtopMenuStyles.backgroundColor ? this.state.mtopMenuStyles : this.state.topMenuStyles}>
                              <Link
                                to=""
                                replace
                                onClick={this.logout}
                                style={this.state.mmenuTopStyles.color ? this.state.mmenuTopStyles : this.state.menuTopStyles}
                              >
                                <i className="glyphicon glyphicon-log-out" /> {languageConfig[this.state.default_lang].logout}
                              </Link>
                            </ListGroupItem>
                          ) : (
                            <ListGroupItem style={this.state.mtopMenuStyles.backgroundColor ? this.state.mtopMenuStyles : this.state.topMenuStyles}>
                              <Link to={"/login"} replace style={this.state.mmenuTopStyles.color ? this.state.mmenuTopStyles : this.state.menuTopStyles}>
                                <i className="glyphicon glyphicon-log-in" /> {languageConfig[this.state.default_lang].login}
                              </Link>
                            </ListGroupItem>
                          )}
                          <ListGroupItem style={this.state.mtopMenuStyles.backgroundColor ? this.state.mtopMenuStyles : this.state.topMenuStyles}>
                              <Link to={"/order/status"} replace style={this.state.mmenuTopStyles.color ? this.state.mmenuTopStyles : this.state.menuTopStyles}>
                                <i className="glyphicon glyphicon-briefcase" /> {languageConfig[this.state.default_lang].where}
                              </Link>
                          </ListGroupItem>
                          {localStorage.getItem("user") ? (
                            <ListGroupItem style={this.state.mtopMenuStyles.backgroundColor ? this.state.mtopMenuStyles : this.state.topMenuStyles}>
                              <Link to={"/my-account"} replace style={this.state.mmenuTopStyles.color ? this.state.mmenuTopStyles : this.state.menuTopStyles}>
                                <i className="glyphicon glyphicon-cog" /> {languageConfig[this.state.default_lang].my_account}
                              </Link>
                            </ListGroupItem>
                          ) : (
                            <ListGroupItem style={this.state.mtopMenuStyles.backgroundColor ? this.state.mtopMenuStyles : this.state.topMenuStyles}>
                              <Link to={"/register"} replace style={this.state.mmenuTopStyles.color ? this.state.mmenuTopStyles : this.state.menuTopStyles}>
                                <i className="glyphicon glyphicon-user" /> {languageConfig[this.state.default_lang].register}
                              </Link>
                            </ListGroupItem>
                          )}
                          {(this.state.multi_lang == 'yes') &&
                            <React.Fragment>
                            {(this.state.default_lang == 'fr') ?
                              <ListGroupItem style={this.state.mtopMenuStyles.backgroundColor ? this.state.mtopMenuStyles : this.state.topMenuStyles}>
                                  <Link to="#" onClick={this.setDefaultLanguage.bind(this, 'en')} replace style={this.state.mmenuTopStyles.color ? this.state.mmenuTopStyles : this.state.menuTopStyles}>
                                    <i className="glyphicon glyphicon-globe" /> English
                                  </Link>
                              </ListGroupItem>
                            :
                              <ListGroupItem style={this.state.mtopMenuStyles.backgroundColor ? this.state.mtopMenuStyles : this.state.topMenuStyles}>
                                  <Link to="#" onClick={this.setDefaultLanguage.bind(this, 'fr')} replace style={this.state.mmenuTopStyles.color ? this.state.mmenuTopStyles : this.state.menuTopStyles}>
                                    <i className="glyphicon glyphicon-globe" /> Français
                                  </Link>
                              </ListGroupItem>
                            }
                            </React.Fragment>
                          }
                        </ListGroup>
                      </div>
                      <div className="top-item">
                        <Row>
                          
  {((isMobile && this.state.search_deals_on_dektop == 'enable') || (!isMobile && this.state.search_deals== 'on')) &&  
                            <Col xs={12} sm={showcity ? 12 : 6} md={showcity || this.state.search_location == 'disable' ? 12 : 6}>
                              <FormGroup>
                                <InputGroup>
                                  <FormControl
                                    type="text"
                                    name="search"
                                    value={this.state.search}
                                    onChange={this.handleSearchText}
                                    placeholder= {languageConfig[this.state.default_lang].search_deal}
                                    onKeyPress={this.handleSearchText}
                                  />
                                  <InputGroup.Addon 
                                  style={{backgroundColor: (this.state.hover && this.state.hoverID == "dealSearch") ? this.state.mmouseover_color ? this.state.mmouseover_color : this.state.mouseover_color : this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color}}
                                  data-id = {'dealSearch'}
                                  onMouseEnter={this.hoverOn} 
                                  onMouseLeave={this.hoverOff}
                                  >
                                    <Glyphicon glyph="search" onClick={this.handleSearch} />
                                  </InputGroup.Addon>
                                </InputGroup>
                              </FormGroup>
                            </Col>
                          }

{((this.state.search_location_mobile != 'on') || (this.state.search_location != 'enable')) &&
                          <Col xs={12} sm={(this.state.multi_lang == 'yes') ? 6 : 6} md={(this.state.multi_lang == 'yes') ? 6 : 6} style={{ display: ((this.state.width <= 720 && this.state.search_location_mobile == 'off') || this.state.search_location == 'disable') ? "none" : "block" }}>
                            {!showcity &&

                              <FormGroup>
                                <InputGroup>
                                  <FormControl componentClass="select" placeholder="select" onChange={this.setDefaultCity}>||
                                    <option value="">{languageConfig[this.state.default_lang].choose_region}</option>
                                    {(this.state.cityList) &&
                                      this.state.cityList.map((data, index) =>
                                        <optgroup key={'hcity'+index} label={data.country}>
                                          {(data.cities) &&
                                            data.cities.map((city, index) => 
                                              <option key={'hcityval'+index} value={city.cityID} selected={this.state.default_city==city.cityID ? true : false} >{city.title}</option>
                                            )
                                          }
                                        </optgroup>
                                      )
                                    }
                                  </FormControl>
                                  <InputGroup.Addon 
                                    style={{backgroundColor: (this.state.hover && this.state.hoverID == "location") ? this.state.mmouseover_color ? this.state.mmouseover_color : this.state.mouseover_color : this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color}}
                                    data-id = {"location"}
                                    onMouseEnter={this.hoverOn} 
                                    onMouseLeave={this.hoverOff} 
                                    onClick={this.findNearestCity}
                                  >
                                    <Glyphicon glyph="map-marker" />
                                  </InputGroup.Addon>
                                </InputGroup>
                              </FormGroup>
                            }
                          </Col>
                        }

{((this.state.search_location_mobile != 'on') || (this.state.search_location != 'enable')) &&
                        <Col xs={12} sm={(this.state.multi_lang == 'yes') ? 6 : 6} md={(this.state.multi_lang == 'yes') ? 6 : 6} style={{ display: (this.state.width <= 720 && this.state.search_location_mobile == 'on') ? "block" : "none" }}>
                            {!showcity &&
                              <FormGroup>
                                <InputGroup>
                                  <FormControl componentClass="select" placeholder="select" onChange={this.setDefaultCity}>||
                                    <option value="">{languageConfig[this.state.default_lang].choose_region}</option>
                                    {(this.state.cityList) &&
                                      this.state.cityList.map((data, index) =>
                                        <optgroup key={'hcity'+index} label={data.country}>
                                          {(data.cities) &&
                                            data.cities.map((city, index) => 
                                              <option key={'hcityval'+index} value={city.cityID} selected={this.state.default_city==city.cityID ? true : false} >{city.title}</option>
                                            )
                                          }
                                        </optgroup>
                                      )
                                    }
                                  </FormControl>
                                  <InputGroup.Addon 
                                    style={{backgroundColor: (this.state.hover && this.state.hoverID == "location") ? this.state.mmouseover_color ? this.state.mmouseover_color : this.state.mouseover_color : this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color}}
                                    data-id = {"location"}
                                    onMouseEnter={this.hoverOn} 
                                    onMouseLeave={this.hoverOff} 
                                    onClick={this.findNearestCity}
                                  >
                                    <Glyphicon glyph="map-marker" />
                                  </InputGroup.Addon>
                                </InputGroup>
                              </FormGroup>
                            }
                          </Col>
                        }

                        {((this.state.search_location_mobile == 'on') && (this.state.search_location == 'enable')) &&
<Col xs={12} sm={(this.state.multi_lang == 'yes') ? 6 : 6} md={(this.state.multi_lang == 'yes') ? 6 : 6} style={{ display: "block" }}>
                            {!showcity &&
                              <FormGroup>
                                <InputGroup>
                                  <FormControl componentClass="select" placeholder="select" onChange={this.setDefaultCity}>||
                                    <option value="">{languageConfig[this.state.default_lang].choose_region}</option>
                                    {(this.state.cityList) &&
                                      this.state.cityList.map((data, index) =>
                                        <optgroup key={'hcity'+index} label={data.country}>
                                          {(data.cities) &&
                                            data.cities.map((city, index) => 
                                              <option key={'hcityval'+index} value={city.cityID} selected={this.state.default_city==city.cityID ? true : false} >{city.title}</option>
                                            )
                                          }
                                        </optgroup>
                                      )
                                    }
                                  </FormControl>
                                  <InputGroup.Addon 
                                    style={{backgroundColor: (this.state.hover && this.state.hoverID == "location") ? this.state.mmouseover_color ? this.state.mmouseover_color : this.state.mouseover_color : this.state.mbutton_color ? this.state.mbutton_color : this.state.button_color}}
                                    data-id = {"location"}
                                    onMouseEnter={this.hoverOn} 
                                    onMouseLeave={this.hoverOff} 
                                    onClick={this.findNearestCity}
                                  >
                                    <Glyphicon glyph="map-marker" />
                                  </InputGroup.Addon>
                                </InputGroup>
                              </FormGroup>
                            }
                          </Col>
}


                        </Row>
                      </div>
                    </Col>
                  </Row> 
                </div>
              </div>
            }
          </div>
        }
        
        {this.props.ismenu && 
          <div ref={this.setWrapperRef}>
            {(siteData && siteData.header_content  && siteData.header_content.dynamic_header_status == 'disable') && 
              <div className="top-menu" style={this.state.mheaderStyles.backgroundColor ? this.state.mheaderStyles : this.state.headerStyles}>
                <div className="container"> 
                  {showcity ?
                    <Row>
                      <Col lg={12} md={12} sm={12}>
                        <Nav stacked className="select-location">
                          <NavDropdown title={this.state.cityTitle && this.state.cityTitle!='' ? this.state.cityTitle : 'Select Your Location'} stacked>
                            <Nav> 
                              {this.state.siteKey == 'zpkt6AuqJMBkOGYBJnDrcuF9JE6bUg0JupDZShM2wpc=' ? 'Select Your Region' : 'Select Your Province'} 
                            </Nav>
                            <Nav>
                              {this.state.stateArr.map((val, idx)=> {
                                  return (<Navbar.Brand id={val} onClick={this.showcity}>
                                    {(val=='CD' ? 'Central Oregon Deals' : (val=='EO' ? 'Eastern Oregon Deals' : (val=='DO' ? 'Discover Our Coast Deals' : val)))}
                                  </Navbar.Brand>) 
                                })
                              }
                            </Nav>
                            <Nav> 
                              Select a City
                            </Nav> 
                            {this.state.stateArr.map((val1, idx1)=> {
                                return (<Nav eventKey={val1} style={this.state.stateAbbr1 ==val1 ? {display:"block"} : {display:"none"}} >
                                  {this.state.cityArr.map((val, idx)=> {
                                    if(val.stateAbbr==val1) {
                                      return (<Navbar.Brand eventKey={val.stateAbbr} onClick={this.setDefaultCity2} id={val.cityID}>
                                        {val.title}
                                      </Navbar.Brand>)
                                    }  
                                    })
                                  }
                                </Nav>) 
                              })
                            }  
                          </NavDropdown>
                        </Nav>
                      </Col>
                    </Row>
                  :
                    ''
                  }
                </div>
              </div>
            }
            {((isMobile && this.state.show_menu_on_desktop == 'enable') || (!isMobile && this.state.show_menu_on_mobile== 'enable')) &&
              <div className="menu">
                <div className="container">
                  <Row>
                    <Col md={12} xs={12}>
                      <Navbar
                        inverse
                        collapseOnSelect
                        style={this.state.mmenuBgStyles.backgroundColor ? this.state.mmenuBgStyles : this.state.menuBgStyles}
                      >
                        <Navbar.Toggle />
                        <Navbar.Collapse>
                          <Nav> 
                          <Navbar.Header>
                          <Navbar.Brand>
                          <Link to={"/"} replace className="pull-right"  style={this.state.mmenuStyles.color ? this.state.mmenuStyles : this.state.menuStyles}>
                          <i className="glyphicon glyphicon-home" />
                          </Link>
                          </Navbar.Brand>
                          </Navbar.Header>
                            {menu}
                          </Nav>
                        </Navbar.Collapse>
                      </Navbar>
                    </Col>
                  </Row>
                </div>
              </div> 
            }
          </div>
        } 
        {(!isEmpty(this.state.notifications)) &&
          <div className="container">
            <Col md={12} xs={12} className="text-center adds">
              {this.state.notifications.map((data, index) => 
                (data.position == 'top') &&
                  <React.Fragment key={data.notificationID + index}>
                  {(data.displayimage != '' || data.mobileappdisplay_image != '') ?
                    (this.state.width > 480 && data.remove_image == 1) ?
                      <React.Fragment>
                        <a href={this.getValidUrl(data.display_image_link)} target="_blank"><Image key={data.notificationID + index} src={data.displayimage} /></a>
                        <Col md={12} xs={12} className="text-center">{(data.message != '') ? ReactHtmlParser(data.message) : ''}</Col>
                      </React.Fragment>
                    :(this.state.width < 480 && data.remove_mobile_app_image == 1) ?
                    <React.Fragment>
                      <a className="adds" href={this.getValidUrl(data.display_image_link)} target="_blank"><Image key={data.notificationID + index} src={data.mobileappdisplay_image} /></a>
                      <Col md={12} xs={12} className={(data.content_type!='Ads Script' ? "text-center" : "text-center ads")}>
                        {data.content_type=='Ads Script' ?
                            data.scripttype=='other' ? 
                              <ScriptSlot datas={data} />
                            :
                              <UseDfpSlot datas={data} />
                          :
                            ((data.message != '') ? ReactHtmlParser(data.message) : '')
                        }
                      </Col>
                    </React.Fragment>
                    :
                    <Well className={(data.content_type!='Ads Script' ? "text-center" : "text-center ads")}>
                      {data.content_type=='Ads Script' ?
                          data.scripttype=='other' ? 
                            <ScriptSlot datas={data} />
                          :
                            <UseDfpSlot datas={data} />
                        :
                          ((data.message != '') ? ReactHtmlParser(data.message) : '')
                      } 
                    </Well>
                  :
                    <Well className={(data.content_type!='Ads Script' ? "text-center" : "text-center ads")}>
                      {data.content_type=='Ads Script' ?
                          data.scripttype=='other' ? 
                            <ScriptSlot datas={data} />
                          :
                            <UseDfpSlot datas={data} />
                        :
                          ((data.message != '') ? ReactHtmlParser(data.message) : '')
                      } 
                    </Well>
                  }
                  </React.Fragment>
              )}
            </Col>
          </div>
        }
      </div>
    );
  }
}

FrontHeader.propTypes = {
  getMenuList: PropTypes.func.isRequired,
  //getQuantityCart: PropTypes.func.isRequired,
  getCartDetail: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  menuList: state.frontReducer.menuList,
  cartDetail: state.frontReducer.cartDetail,
  //cartQuantity: state.frontReducer.cartQuantity,
  cartStatus: state.frontReducer.cartStatus,
  logoutStatus: state.frontReducer.logoutStatus,
  cityList: state.frontReducer.cityList,
  siteStatus: state.siteReducer.siteStatus,
  error: state.frontReducer.error,
  curDeal: state.frontReducer.curDeal,
  currentCityID: state.frontReducer.currentCityID,
})

export default connect(mapStateToProps, {
  getMenuList,
  //getQuantityCart,
  getCartDetail,
  userLogout,
  getSiteCity,
  getSiteStatus,
  currentDealList
})(FrontHeader);


// WEBPACK FOOTER //
// ./src/app/views/frontend/Header/Header.js